// extracted by mini-css-extract-plugin
module.exports = {"videoFrame":"_1fj9QHEapPR1Ythw6MizpH"};